import { sva } from '@/styled-system/css';

export const drawerRecipe = sva({
  slots: ['backdrop', 'content', 'header', 'close'],
  base: {
    backdrop: {
      placeItems: 'start',
      paddingBlock: 'zero',
      paddingInline: 'zero',
    },
    content: {
      blockSize: '100dvh',
      borderRadius: 'none',
    },
    header: {},
    close: {},
  },
  variants: {
    placement: {
      start: {
        content: {
          animation: 'slide-in-start',
          // Slide from the inline-start edge; flip for RTL so the entry
          // direction tracks the writing mode.
          '--drawer-slide-from': '-100%',
          _rtl: { '--drawer-slide-from': '100%' },
          // Honor prefers-reduced-motion: reduce.
          _motionReduce: { animation: 'none' },
        },
        header: {
          paddingInlineStart: 'Modal.Header.padding.right',
          paddingInlineEnd: 'Modal.Header.padding.left',
        },
        close: {
          insetBlockStart: 'chrome.gutter',
          insetInlineEnd: 'auto',
          insetInlineStart: 'chrome.gutter',
        },
      },
      end: {
        content: {
          animation: 'slide-in-end',
          justifySelf: 'end',
          '--drawer-slide-from': '100%',
          _rtl: { '--drawer-slide-from': '-100%' },
          _motionReduce: { animation: 'none' },
        },
      },
    },
  },
});
